<svg width="32" height="32" viewBox="0 0 32 32" fill="none" xmlns="http://www.w3.org/2000/svg">
<mask id="mask0_476_2963" style="mask-type:alpha" maskUnits="userSpaceOnUse" x="0" y="0" width="32" height="32">
<rect width="32" height="32" />
</mask>
<g mask="url(#mask0_476_2963)">
<path d="M5.33333 28V25.3334H21.3333V28H5.33333ZM12.8667 21.5334L5.33333 14L8.13333 11.1334L15.7333 18.6667L12.8667 21.5334ZM21.3333 13.0667L13.8 5.46669L16.6667 2.66669L24.2 10.2L21.3333 13.0667ZM27.4667 26.6667L10.0667 9.26669L11.9333 7.40002L29.3333 24.8L27.4667 26.6667Z" />
</g>
</svg>
